import React from "react";
import { Tooltip, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Statuses, TotalSteps } from "../constant/status";

const { Text } = Typography;

const Cycle = ({ isCompleted }) => (
  <div
    style={{
      height: 11,
      width: 11,
      margin: 5,
      borderRadius: "50%",
      backgroundColor: isCompleted ? "#2B56A3" : "#C4C4C4"
    }}
  />
);

const StatusIcon = ({ status, isFreeDrug }) => {
  const { t } = useTranslation();
  const statusObj = Object.values(Statuses).find((s) => s.key === status);
  const title = statusObj?.title(t);
  const icon = statusObj?.icon;
  const currStep = statusObj?.step(isFreeDrug);
  return (
    <Tooltip title={<Text>{title}</Text>} color={"white"}>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", paddingRight: "5px" }}>
        <div style={{ display: "flex", paddingRight: 6, alignItems: "center" }}>{icon}</div>
        {Array.from(Array(TotalSteps)).map((step, index) => (
          <Cycle key={index} isCompleted={index <= currStep - 1} />
        ))}
      </div>
    </Tooltip>
  );
};

export { StatusIcon };
